/* eslint-disable max-len */
import React from "react";
import { Formik, Form, Field } from 'formik';
import l from "components/util/l";
import StyleColor from "components/util/helpers/StyleColor"
import { ColorPicker, getDarkerColor } from "components/vmisc/onboarding/Onboarding.sub.colorpicker.view";
import "styles/css/vmisc/Onboarding.css";


const OnboardingView = ({
  user,
  step,
  profiles,
  onClickNextStep,
  onClickBackStep,
  onClickSkipOnboarding,
  onSubmit
}) => (

  <div class="container-fluid px-3">
    <StyleColor />
    <div class="row">
      <div class="col-lg-7 d-flex justify-content-center align-items-center min-vh-100 position-relative bg-light px-0">
        <div class="position-absolute top-0 left-0 right-0 mt-3 mx-3">
          <div class="d-flex justify-content-between">
            <a href="/">
              <img class="w-100" src="/theme/svg/logos/logo.svg" alt="Image Description" style={{ minWidth: "10rem", maxWidth: "10rem" }} />
            </a>
          </div>
        </div>

        <div class="w-100 pt-10 pt-lg-7 pb-7" style={{ maxWidth: "40rem" }}>

          <Formik
            initialValues={{}}
            onSubmit={onSubmit}
          >
            {({ values, setFieldValue, handleSubmit }) => (
              <Form>

                <div class="text-center mb-5">
                  <h1 class="display-4">¡Bienvenido a Workix!</h1>
                </div>

                <div class="text-center mb-4">
                  <h4>Te estás registrando como {user.email}</h4>
                </div>

                {step == 1 && (
                  <div className="mb-4">
                    <div class="form-group">
                      <label class="input-label" for="firstName">Nombre(s)</label>
                      <Field type="text" class="form-control" name="firstName" id="firstName" required />
                    </div>

                    <div class="form-group">
                      <label class="input-label" for="lastName">Apellidos</label>
                      <Field type="text" class="form-control" name="lastName" id="lastName" required />
                    </div>

                    <div class="form-group">
                      <label class="input-label" for="password">Contraseña</label>
                      <div class="input-group input-group-merge">
                        <Field type="password" class="form-control" name="password" id="password" required />
                        <div class="js-toggle-password-target-1 input-group-append">
                          <a class="input-group-text" href="javascript:;">
                            <i class="js-toggle-passowrd-show-icon-1 tio-hidden-outlined"></i>
                          </a>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="input-label" for="confirmPassword">Confirmar contraseña</label>
                      <div class="input-group input-group-merge">
                        <Field type="password" class="form-control" name="confirmPassword" id="confirmPassword" required />
                        <div class="js-toggle-password-target-2 input-group-append">
                          <a class="input-group-text" href="javascript:;">
                            <i class="js-toggle-passowrd-show-icon-2 tio-hidden-outlined"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {step == 2 && (
                  <div className="mb-4">
                    <div>
                      <div className="text-center mb-4" style={{ fontSize: "1.15rem" }}>
                        Ahora selecciona los colores para Workix
                      </div>
                      <div className="card p-0" style={{ borderRadius: "0" }}>
                        <div className="card-body p-0">

                          <div className="row mx-0">
                            <div className="col-md-8 p-0">
                              <div className="bg-img-hero"
                                style={{
                                  pointerEvents: "none",
                                  height: "15rem"
                                }}>

                                <figure style={{ height: "100%" }}>
                                  <svg preserveAspectRatio="none" viewBox="0 0 1920 698" fill="none" xmlns="http://www.w3.org/2000/svg"
                                    style={{
                                      height: "100%",
                                      width: "100%",
                                    }}>
                                    <rect width="1920" height="698" fill="#fff" />
                                    <g clipPath="url(#clip0)">
                                      <path className="path-a" d="M1920 -714.403H0V1412.4H1920V-714.403Z" fill={values?.primaryColor ? getDarkerColor(values.primaryColor, -30) : getDarkerColor("#2080e5", -30)} />
                                      <path className="path-b" d="M1298.9 -5488.72L2618.5 1300.02L1702.8 1842.02C1651.6 1690.56 1569.6 1565.26 1479.9 1480.46C1338.1 1346.44 1176.9 1292.52 1020.9 1221.67C933 1182.06 832 1111.56 811.9 957.132C799 858.54 824.8 759.075 837.2 660.308C869.8 400.128 798.7 110.284 668.3 -28.0949C635.9 -62.4714 599.1 -90.391 577.4 -144.661C510.4 -312.18 639.3 -526.467 627 -729.759C622.6 -803.224 599.6 -869.01 574.6 -928.689C300.4 -1585.86 -209.4 -1749.54 -628.8 -2103.6C-751.2 -2207.08 -871.1 -2334.11 -955 -2520.83C-1038.9 -2707.72 -1081.4 -2964.58 -1036.1 -3188.29C-974.1 -3494.19 -776.5 -3644.26 -593.7 -3703.76C-410.9 -3763.27 -215.6 -3771.47 -56 -3937.77C117.6 -4118.72 216 -4451.32 351 -4713.77C418.6 -4845.17 495.6 -4958.94 577.8 -5061.9L1298.9 -5488.72Z" fill={values?.primaryColor ?? "#2080e5"} />
                                      <path className="path-c" d="M1733.2 -6299.97L3053 487.553L2137.2 1029.55C2086 878.084 2004 752.968 1914.3 668.161C1772.5 534.145 1611.3 480.224 1455.2 409.552C1367.3 369.766 1266.3 299.443 1246.2 145.01C1233.4 46.4176 1259.2 -53.0476 1271.5 -151.815C1304.1 -411.994 1233 -701.664 1102.6 -840.217C1070.2 -874.594 1033.4 -902.514 1011.7 -956.783C944.7 -1124.3 1073.6 -1338.59 1061.3 -1541.71C1056.9 -1615.17 1033.8 -1680.96 1008.9 -1740.64C734.8 -2397.63 224.9 -2561.31 -194.5 -2915.37C-316.9 -3018.85 -436.8 -3145.71 -520.7 -3332.6C-604.6 -3519.32 -647.1 -3776.18 -601.8 -3999.89C-539.8 -4305.61 -342.2 -4455.86 -159.4 -4515.36C23.3999 -4574.87 218.7 -4583.07 378.3 -4749.37C551.8 -4930.15 650.2 -5262.75 785.2 -5525.02C852.8 -5656.42 929.8 -5770.19 1012 -5873.15L1733.2 -6299.97Z" fill={values?.accentColor ?? "#f0b000"} />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0">
                                        <rect width="1920" height="698" fill="white" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </figure>
                              </div>
                            </div>
                            <div className="col-md-4 p-0">
                              <div className="d-flex h-100 w-100 justify-content-center align-items-center">
                                <div>
                                  <ColorPicker
                                    label={l("Color principal%VE008")}
                                    name="primaryColor"
                                    values={values}
                                    defaultColor={"#2065a5"}
                                    setFieldValue={setFieldValue}
                                  />

                                  <ColorPicker
                                    label={l("Color de acento%VE009")}
                                    name="accentColor"
                                    values={values}
                                    defaultColor={"#f0b000"}
                                    setFieldValue={setFieldValue}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <button type="submit" class="btn btn-lg btn-block btn-primary mb-2">Continuar</button>
              </Form>
            )}
          </Formik>

        </div>

      </div>

      <div class="col-lg-5 d-none d-lg-flex justify-content-center align-items-center min-vh-lg-100">
        <div className="position-absolute top-0 right-0 left-0 bg-img-hero w-100 h-100"
          id="background-hero">

          <figure className="position-absolute top-0 right-0 left-0 w-100 h-100 overflow-hidden">
            <svg preserveAspectRatio="none" viewBox="0 0 1920 698" fill="none" xmlns="http://www.w3.org/2000/svg"
              transform="rotate(270)"
              >
              <rect width="1920" height="698" fill="#fff" />
              <g clipPath="url(#clip0)">
                <path className="path-a" d="M1920 -714.403H0V1412.4H1920V-714.403Z" fill="#2065a5" />
                <path className="path-b" d="M1298.9 -5488.72L2618.5 1300.02L1702.8 1842.02C1651.6 1690.56 1569.6 1565.26 1479.9 1480.46C1338.1 1346.44 1176.9 1292.52 1020.9 1221.67C933 1182.06 832 1111.56 811.9 957.132C799 858.54 824.8 759.075 837.2 660.308C869.8 400.128 798.7 110.284 668.3 -28.0949C635.9 -62.4714 599.1 -90.391 577.4 -144.661C510.4 -312.18 639.3 -526.467 627 -729.759C622.6 -803.224 599.6 -869.01 574.6 -928.689C300.4 -1585.86 -209.4 -1749.54 -628.8 -2103.6C-751.2 -2207.08 -871.1 -2334.11 -955 -2520.83C-1038.9 -2707.72 -1081.4 -2964.58 -1036.1 -3188.29C-974.1 -3494.19 -776.5 -3644.26 -593.7 -3703.76C-410.9 -3763.27 -215.6 -3771.47 -56 -3937.77C117.6 -4118.72 216 -4451.32 351 -4713.77C418.6 -4845.17 495.6 -4958.94 577.8 -5061.9L1298.9 -5488.72Z" fill="#205595" />
                <path className="path-c" d="M1733.2 -6299.97L3053 487.553L2137.2 1029.55C2086 878.084 2004 752.968 1914.3 668.161C1772.5 534.145 1611.3 480.224 1455.2 409.552C1367.3 369.766 1266.3 299.443 1246.2 145.01C1233.4 46.4176 1259.2 -53.0476 1271.5 -151.815C1304.1 -411.994 1233 -701.664 1102.6 -840.217C1070.2 -874.594 1033.4 -902.514 1011.7 -956.783C944.7 -1124.3 1073.6 -1338.59 1061.3 -1541.71C1056.9 -1615.17 1033.8 -1680.96 1008.9 -1740.64C734.8 -2397.63 224.9 -2561.31 -194.5 -2915.37C-316.9 -3018.85 -436.8 -3145.71 -520.7 -3332.6C-604.6 -3519.32 -647.1 -3776.18 -601.8 -3999.89C-539.8 -4305.61 -342.2 -4455.86 -159.4 -4515.36C23.3999 -4574.87 218.7 -4583.07 378.3 -4749.37C551.8 -4930.15 650.2 -5262.75 785.2 -5525.02C852.8 -5656.42 929.8 -5770.19 1012 -5873.15L1733.2 -6299.97Z" fill="#104a8a" />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="1920" height="698" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </figure>

        </div>



      </div>
    </div>
  </div>

  // <div className="card">
  //   <div id="onboarding" className="card-body">

  //     <h4 className="text-center my-3" style={{ fontSize: "1.75rem" }}>
  //       {l("Bienvenido a Workix%VE006")}
  //     </h4>

  //     <div className="my-2">
  //       <Formik
  //         initialValues={{}}
  //         onSubmit={onSubmit}
  //       >
  //         {({ values, setFieldValue, handleSubmit }) => (
  //           <Form>

  //             {step == 1 && (
  //               <div>
  //                 <div className="text-center mb-4" style={{ fontSize: "1.15rem" }}>
  //                   {l("Para iniciar, selecciona tus colores para Workix%VE007")}
  //                 </div>
  //                 <div className="card p-0" style={{ borderRadius: "0" }}>
  //                   <div className="card-body p-0">

  //                     <div className="row mx-0">
  //                       <div className="col-md-8 p-0">
  //                         <div className="bg-img-hero"
  //                           style={{
  //                             pointerEvents: "none",
  //                             height: "15rem"
  //                           }}>

  //                           <figure style={{ height: "100%" }}>
  //                             <svg preserveAspectRatio="none" viewBox="0 0 1920 698" fill="none" xmlns="http://www.w3.org/2000/svg"
  //                               style={{
  //                                 height: "100%",
  //                                 width: "100%",
  //                               }}>
  //                               <rect width="1920" height="698" fill="#fff" />
  //                               <g clipPath="url(#clip0)">
  //                                 <path className="path-a" d="M1920 -714.403H0V1412.4H1920V-714.403Z" fill={values?.primaryColor ? getDarkerColor(values.primaryColor, -30) : getDarkerColor("#2080e5", -30)} />
  //                                 <path className="path-b" d="M1298.9 -5488.72L2618.5 1300.02L1702.8 1842.02C1651.6 1690.56 1569.6 1565.26 1479.9 1480.46C1338.1 1346.44 1176.9 1292.52 1020.9 1221.67C933 1182.06 832 1111.56 811.9 957.132C799 858.54 824.8 759.075 837.2 660.308C869.8 400.128 798.7 110.284 668.3 -28.0949C635.9 -62.4714 599.1 -90.391 577.4 -144.661C510.4 -312.18 639.3 -526.467 627 -729.759C622.6 -803.224 599.6 -869.01 574.6 -928.689C300.4 -1585.86 -209.4 -1749.54 -628.8 -2103.6C-751.2 -2207.08 -871.1 -2334.11 -955 -2520.83C-1038.9 -2707.72 -1081.4 -2964.58 -1036.1 -3188.29C-974.1 -3494.19 -776.5 -3644.26 -593.7 -3703.76C-410.9 -3763.27 -215.6 -3771.47 -56 -3937.77C117.6 -4118.72 216 -4451.32 351 -4713.77C418.6 -4845.17 495.6 -4958.94 577.8 -5061.9L1298.9 -5488.72Z" fill={values?.primaryColor ?? "#2080e5"} />
  //                                 <path className="path-c" d="M1733.2 -6299.97L3053 487.553L2137.2 1029.55C2086 878.084 2004 752.968 1914.3 668.161C1772.5 534.145 1611.3 480.224 1455.2 409.552C1367.3 369.766 1266.3 299.443 1246.2 145.01C1233.4 46.4176 1259.2 -53.0476 1271.5 -151.815C1304.1 -411.994 1233 -701.664 1102.6 -840.217C1070.2 -874.594 1033.4 -902.514 1011.7 -956.783C944.7 -1124.3 1073.6 -1338.59 1061.3 -1541.71C1056.9 -1615.17 1033.8 -1680.96 1008.9 -1740.64C734.8 -2397.63 224.9 -2561.31 -194.5 -2915.37C-316.9 -3018.85 -436.8 -3145.71 -520.7 -3332.6C-604.6 -3519.32 -647.1 -3776.18 -601.8 -3999.89C-539.8 -4305.61 -342.2 -4455.86 -159.4 -4515.36C23.3999 -4574.87 218.7 -4583.07 378.3 -4749.37C551.8 -4930.15 650.2 -5262.75 785.2 -5525.02C852.8 -5656.42 929.8 -5770.19 1012 -5873.15L1733.2 -6299.97Z" fill={values?.accentColor ?? "#f0b000"} />
  //                               </g>
  //                               <defs>
  //                                 <clipPath id="clip0">
  //                                   <rect width="1920" height="698" fill="white" />
  //                                 </clipPath>
  //                               </defs>
  //                             </svg>
  //                           </figure>
  //                         </div>
  //                       </div>

  //                       <div className="col-md-4 p-0">
  //                         <div className="d-flex h-100 w-100 justify-content-center align-items-center">
  //                           <div>
  //                             <ColorPicker
  //                               label={l("Color principal%VE008")}
  //                               name="primaryColor"
  //                               values={values}
  //                               defaultColor={"#2065a5"}
  //                               setFieldValue={setFieldValue}
  //                             />

  //                             <ColorPicker
  //                               label={l("Color de acento%VE009")}
  //                               name="accentColor"
  //                               values={values}
  //                               defaultColor={"#f0b000"}
  //                               setFieldValue={setFieldValue}
  //                             />
  //                           </div>
  //                         </div>
  //                       </div>
  //                     </div>
  //                   </div>
  //                 </div>

  //                 <div className="d-flex w-100 mt-3 justify-content-between">
  //                   {/*<button className="btn btn-secondary" type="button" onClick={onClickSkipOnboarding}>
  //                     <i class="fas fa-forward mr-2"></i>Saltar
  //                   </button>*/}
  //                   <div></div>
  //                   <button type="submit" className="btn btn-success">
  //                     <i class="fas fa-check mr-2"></i>{l("Finalizar%VE010")}
  //                   </button>
  //                 </div>

  //               </div>
  //             )}

  //           </Form>
  //         )}
  //       </Formik>
  //     </div>

  //   </div>
  // </div>
);

export default OnboardingView;